import React from "react";

export default function LastingImpactSection({ data }) {
  if (!data) return null;

  return (
    <section className="lasting-impact-section">
      <div className="container">
        <div className="lasting-impact-section-heading text-center">
          <span>{data.eyebrow}</span>
          <h2 className="heading">{data.title}</h2>
        </div>

        <div className="row lasting-impact-section-cards">
          {data.items.map((item) => (
            <div className="col-lg-3 col-md-6" key={item.title}>
              <article
                className="lasting-impact-card"
                style={{ "--impact-color": item.color }}
              >
                <span className="lasting-impact-card-icon">
                  <img src={item.iconImage} alt={item.iconAlt || ""} />
                </span>

                <div className="lasting-impact-card-content">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
